import { Component, inject, OnInit } from '@angular/core';
import { StepperModule } from 'primeng/stepper';
import { AdminBoilerplateComponent } from '../../../../core/admin-boilerplate/feature/admin-boilerplate.component';
import { AccordionComponent, AccordionPanelComponent } from "../../../../core/accordion/feature/accordion.component";
import { Store } from '@ngrx/store';
import { selectAdminEventSystem, selectAdminEventSystems, selectAdminOrganiser, selectAdminPermittedEventHosts, selectAdminPermittedEventSystems, selectAllAdminOrganisers, selectOrganiserVerified } from '../../../../data-services/stores/selectors/admin.selectors';
import { adminActions } from '../../../../data-services/stores/actions/admin.actions';
import { CommonModule } from '@angular/common';
import { EventSystemActions } from '../../../../data-services/stores/actions/event-system.actions';
import { AuthService } from '../../../../data-services/auth.service';
import { Observable, of, tap } from 'rxjs';
import { SkeletonModule } from 'primeng/skeleton';
import { FormGroup, FormControl, ɵInternalFormsSharedModule, FormsModule, ReactiveFormsModule, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { FileUpload, FileUploadErrorEvent, UploadEvent } from 'primeng/fileupload';
import { dateRangeValidator } from '../../../../data-services/validators/date.validators';
import { Editor } from "primeng/editor";
import { HttpHeaders } from '@angular/common/http';
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { Organiser } from '../../../../data-services/models/organisers/organiser.model';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'admin-new-event',
  imports: [AdminBoilerplateComponent, StepperModule, AccordionComponent, AccordionPanelComponent, CommonModule, SkeletonModule, ɵInternalFormsSharedModule, FormsModule, ReactiveFormsModule, Editor, FileUpload, FaIconComponent,RouterModule],
  templateUrl: '../ui/new.component.html',
  styleUrl: '../ui/new.component.css'
})
export class AdminNewEventComponent implements OnInit {
  private readonly _store = inject(Store);
  private readonly _auth = inject(AuthService);
  //organiser$?: Observable<Organiser | undefined>;
  selectOrganiserVerified$?: Observable<boolean | undefined>;
  disableCreate: boolean = false;

  eventFormOne: FormGroup = new FormGroup({
    systemID: new FormControl<number>(0, [Validators.required, Validators.min(1)]),
    hostID: new FormControl<number>(0, [Validators.required, Validators.min(1)]),
    organiserID: new FormControl<number>(0, [Validators.required, Validators.min(1)]),
    eventName: new FormControl<string>('', [Validators.required, Validators.minLength(3)])
  })

  eventFormTwo: FormGroup = new FormGroup({
    startDate: new FormControl<Date | undefined>(undefined, [Validators.required]),
    endDate: new FormControl<Date | undefined>(undefined, [Validators.required]),
    location: new FormControl<string>('', [Validators.required, Validators.minLength(3)])
  }, { validators: dateRangeValidator('startDate', 'endDate') })

  eventFormThree: FormGroup = new FormGroup({
    characterInvitation: new FormControl<string>('', [Validators.required, Validators.minLength(3)])
  })

  eventFormFour: FormGroup = new FormGroup({
    eventInformation: new FormControl<string>('', [Validators.required, Validators.minLength(3)])
  })

  eventFormFive: FormGroup = new FormGroup({
    promoDescription: new FormControl<string>('', [Validators.required, Validators.minLength(3)])
  })

  permittedEventSystems$ = this._store.select(selectAdminPermittedEventSystems).pipe(
    tap(x => {
      if (x.length === 1) this.eventFormOne.controls['systemID'].setValue(x[0].systemID)
    }))
  permittedEventHosts$ = this._store.select(selectAdminPermittedEventHosts(this.eventFormOne.controls['systemID'].value)).pipe(
    tap(x => {
      if (x.length === 1) this.eventFormOne.controls['hostID'].setValue(x[0].hostID)
    }))
  availableOrganisers$ = this._store.select(selectAllAdminOrganisers).pipe(
    tap(x => {
      if (x.length === 1) this.eventFormOne.controls['organiserID'].setValue(x[0].organiserID)
    }))
  currentStep: number = 0;

  promoPlaceholders: string[] = [
    'Dive into the dwarven stronghold and uncover the mysteries behind the ancient relics hidden within',
    'LRP Tickets invites you all to an evening of mystery and intrique at our annual masquerade ball',
  ]

  ngOnInit(): void {
    this._store.dispatch(EventSystemActions.loadEventSystems());
    this._store.dispatch(adminActions.getEventHosts());
    this._store.dispatch(adminActions.getOrganisers());
  }

  updateEventHosts(){
    this.permittedEventHosts$ = 
      this._store.select(selectAdminPermittedEventHosts(this.eventFormOne.controls['systemID'].value))
      .pipe(
        tap(x => {
          if (x.length === 1) this.eventFormOne.controls['hostID'].setValue(x[0].hostID)
        }
      ))
  }

  createEvent(){
    this.disableCreate = true;
    this._store.dispatch(adminActions.createNewEvent({lrpEvent: {
      systemID: this.eventFormOne.value.systemID,
      hostID: this.eventFormOne.value.hostID,
      organiserID: this.eventFormOne.value.organiserID,
      name: this.eventFormOne.value.eventName,
      icInvitation: this.eventFormThree.value.characterInvitation,
      eventDescription: this.eventFormFour.value.eventInformation,
      promoDescription: this.eventFormFive.value.promoDescription,
      eventStart: this.eventFormTwo.value.startDate,
      eventEnd: this.eventFormTwo.value.endDate,
      location: this.eventFormTwo.value.location
    } }))
  }

  organiserChanged(){
    const organiserId = this.eventFormOne.controls['organiserID'].value ;
    if (organiserId > 0){
      //this.organiser$ = this._store.select(selectAdminOrganiser(organiserId))
      this.selectOrganiserVerified$ = this._store.select(selectOrganiserVerified(organiserId))
    }
  }
}